import { useFormik } from "formik";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import Loading from "../../../../components/loader/Loading";
import PageTitle from "../../../../components/partials/PageTitle";
import { filterSpecificOffice } from "../../../../components/policy/edit/Settings";
import Account from "../../../../components/policy/edit/savings/Account";
import Cover from "../../../../components/policy/edit/savings/Cover";
import GeneralInformation from "../../../../components/policy/edit/savings/GeneralInformation";
import SavingsInterest from "../../../../components/policy/edit/savings/SavingsInterest";
import Settings from "../../../../components/policy/edit/savings/Settings";
import { getUnpaginatedCharges } from "../../../../redux/slice/charges/chargesSlice";
import { getPolicyCoverByCategory } from "../../../../redux/slice/policy/policySlice";
import {
  getSingleSavingsPolicy,
  resetPolicyStatus,
  updateSavingsPolicy,
} from "../../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import { flashMessage as flash } from "../../../../utils/flash/index";
import { savingsPolicyEdit } from "../../../../utils/validators/schema";


const multipleData = [
  { name: 'Total Contribution', id: 'total contribution'},
  { name: 'Savings Balance', id: 'savings balance'},
]

const filterMultiple = (multipleData, multiple_value) => {
  return multipleData
    ?.filter((item, i) =>
      multiple_value?.some(
        (data) => item?.id === data
      )
    )
    .map((value) => ({
      label: value?.name,
      value: value.id,
    }));
  };
const EditSavingsPolicy = () => {
  const [hasEditPolicy, setHasEditPolicy] = useState();

  const { single_policy, isSuccess, isLoading, isUpdated } = useSelector(
    (state) => state.savingsPolicy
  );
  const {
    offices: { offices },
  } = useSelector((state) => state?.office);
  const { gl_accounts } = useSelector((state) => state.accounting);
  const { user, user_permissions } = useSelector((state) => state?.auth?.user);
  const { unpaginated_charges } = useSelector((state) => state?.charges);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [policy, setPolicy] = useState(single_policy?.data);
  const [glAccounts, setGLAccounts] = useState(gl_accounts);
  const [edit, setEdit] = useState(false);

  // breadcrumb nav
  const breadcrumb = {
    from: {
      title: "Policies",
      link: "/admin/savings-policy",
    },
    current: {
      title: "edit policy",
      link: null,
    },
  };

  const onSubmit = (values) => {
    let payload = {
      policy_savings_general: {
        policy_name: values?.policy_name,
        short_name: values?.short_name,
        minimum_duration: values?.minimum_duration,
        currency: values?.currency,
        minimum_age: values?.minimum_age,
        maximum_age: values?.maximum_age,
        description: values?.description,
      },
      policy_savings_interest: {
        default_rate: values?.default_interest_rate,
        minimum_rate: values?.minimum_interest_rate,
        maximum_rate: values?.maximum_interest_rate,
        // interest_cal_type: values?.interest_cal_type,
        // interest_posting_period: values?.interest_posting_period,
        // interest_compound_period: values?.interest_compound_period,
      },
      policy_savings_accounting: {
        income_gl: values?.income_gl,
        expense_gl: values?.expense_gl,
        interest_expense_gl: (values?.interest_expense_gl).toString(),
        asset_gl: values?.asset_gl,
        liability_gl: values?.liability_gl,
        provision_gl: values?.provision_gl,
        tax_gl: values?.tax_gl,
      },
      expires_at: values?.expires_at,
      charges: [...values.charges.map((item) => ({ charge_id: item.value }))],
      restrict_withdrawal: values?.restrict_withdrawal ? 1 : 0,
      partial_withdrawal: {
        max_withdrawal_limit: values?.max_withdrawal_limit,
        withdrawal_penalty: values?.withdrawal_penalty,
      },
      termination: {
        penalty_period: values?.penalty_period,
        penalty_value: values?.penalty_value,
      },
      cool_off: {
        cool_off_period: values?.cool_off_period,
        cool_off_value: values?.cool_off_value,
      },
    };
    if (values?.apply_to === "SO") {
      payload = {
        ...payload,
        specific_offices: [
          ...values?.specific_offices?.map((item) => ({
            office_id: item?.value,
          })),
        ],
      };
    } else if (values?.apply_to === "CW") {
      payload = {
        ...payload,
        company_wide: true,
      };
    } else if (values?.apply_to === "RAB") {
      payload = {
        ...payload,
        region_area_branch: values.region_area_branch,
        sub_offices: values?.sub_offices ? 1 : 0,
      };
    }
    if (values?.cover?.length) {
      payload = {
        ...payload,
        other_cover: values?.cover,
      };
    }
    if (values?.lifeCover?.length) {
      payload = {
        ...payload,
        life_cover: values?.lifeCover,
      };
    }
    if (values?.life_cover_claim_name === "assumed") {
      payload = { ...payload, life_cover_claim_name: values.life_cover_claim_name };
    }
    if (values?.life_cover_claim_name === "multiple") {
      payload = { 
        ...payload,
        life_cover_claim_name: values.life_cover_claim_name ,
        value: values?.multiple_value?.map(item =>  ( item.value ))
      };
    }
    if (values?.life_cover_claim_name === "guaranteed") {
      if (values?.assumed_garranty_type === "fixed") {
        payload = { 
          ...payload,
          life_cover_claim_name: values.life_cover_claim_name ,
          guaranteed_type: values.assumed_garranty_type ,
          value: values?.assumed_garranty_value
        };
      } else {
        payload = { 
          ...payload,
          life_cover_claim_name: values.life_cover_claim_name ,
          guaranteed_type: values.assumed_garranty_type ,
          assumed_garranty_minimum: values.assumed_garranty_minimum,
          assumed_garranty_maximum: values.assumed_garranty_maximum,
        };
      }
    }
    dispatch(
      updateSavingsPolicy({
        payload,
        id,
      })
    );
  };

  const applyTo = useCallback(() => {
    let result = "";
    if (
      policy?.settings?.region_area_branch !== "nil" &&
      policy?.settings?.region_area_branch !== null &&
      policy?.settings?.region_area_branch !== undefined &&
      policy?.settings?.region_area_branch !== 0 &&
      policy?.settings?.region_area_branch !== ""
    ) {
      result = "RAB";
    } else if (
      policy?.settings?.company_wide !== "nil" &&
      policy?.settings?.company_wide !== null &&
      policy?.settings?.company_wide !== undefined &&
      policy?.settings?.company_wide !== 0 &&
      policy?.settings?.company_wide !== ""
    ) {
      result = "CW";
    } else if (
      policy?.settings?.specific_offices !== "nil" &&
      policy?.settings?.specific_offices !== null &&
      policy?.settings?.specific_offices !== undefined &&
      policy?.settings?.specific_offices !== ""
    ) {
      result = "SO";
    }
    return result;
  }, [policy]);
  
  const {
    errors,
    values,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
    setFieldTouched,
    setFieldError,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      policy_name: policy?.savings_policy_general?.policy_name || "",
      short_name: policy?.savings_policy_general?.short_name || "",
      minimum_duration: policy?.savings_policy_general?.minimum_duration || "",
      currency: policy?.savings_policy_general?.currency || "",
      minimum_age: policy?.savings_policy_general?.minimum_age || "",
      maximum_age: policy?.savings_policy_general?.maximum_age || "",
      description: policy?.savings_policy_general?.description || "",
      default_interest_rate: policy?.interest?.default_rate || "",
      minimum_interest_rate: policy?.interest?.minimum_rate || "",
      maximum_interest_rate: policy?.interest?.maximum_rate || "",
      // interest_cal_type: policy?.interest?.interest_cal_type || "",
      // interest_posting_period: policy?.interest?.interest_posting_period || "",
      // interest_compound_period:
      //   policy?.interest?.interest_compound_period || "",
      income_gl: policy?.account?.income_gl || "",
      expense_gl: policy?.account?.expense_gl || "",
      interest_expense_gl: policy?.account?.interest_expense_gl || "",
      asset_gl: policy?.account?.asset_gl || "",
      liability_gl: policy?.account?.liability_gl || "",
      provision_gl: policy?.account?.provision_gl || "",
      tax_gl: policy?.account?.tax_gl || "",
      charges: policy?.charge.map((charge) => {
        const matchingCharge = unpaginated_charges?.get_savings_charge?.find(
          (c) => c.id === charge.charge_id
        );

        return matchingCharge
          ? {
              value: matchingCharge.id,
              charge_name: matchingCharge.charge_name,
            }
          : null; // handle cases where charge_id doesn't match
      }),
      life_cover_claim_name: policy?.LifeCoverClaimDetails?.life_cover_claim_name || "",
      multiple_value: policy?.LifeCoverClaimValue?.multiple_value ? filterMultiple(multipleData, JSON.parse(policy?.LifeCoverClaimValue?.multiple_value)) : [],
      assumed_garranty_type: policy?.LifeCoverClaimValue?.assumed_garranty_type || "fixed",
      assumed_garranty_value: policy?.LifeCoverClaimValue?.assumed_garranty_value || "",
      assumed_garranty_minimum: policy?.LifeCoverClaimValue?.assumed_garranty_minimum || "",
      assumed_garranty_maximum: policy?.LifeCoverClaimValue?.assumed_garranty_maximum || "",
      cover: policy?.cover[0]?.other_cover ? JSON.parse(policy?.cover[0]?.other_cover) : [],
      lifeCover: policy && JSON.parse(policy?.cover[0]?.life_cover),
      company_wide: policy?.settings?.company_wide || null,
      region_area_branch: policy?.settings?.region_area_branch || null,
      sub_offices: policy?.settings?.sub_offices ? true : false || null,
      specific_offices:
        policy?.settings?.specific_offices === 1
          ? filterSpecificOffice(offices, policy?.specific_offices)
          : "nil",
      applied_offices: policy?.specific_offices || [],
      expires_at: policy?.settings?.expires_at || "",
      apply_to: applyTo(),
      restrict_withdrawal: policy?.settings?.restrict_withrawal
        ? true
        : false || "",
      max_withdrawal_limit:
        policy?.partial_withdrawal?.max_withdrawal_limit_before_maturity || "",
      withdrawal_penalty: policy?.partial_withdrawal?.withdrawal_penalty || "",
      penalty_period: policy?.termination?.penalty_period || "",
      penalty_value: policy?.termination?.penalty_value || "",
      cool_off_period: policy?.cool_off?.cool_off_period || "",
      cool_off_value: policy?.cool_off?.cool_off_value || "",
    },
    validationSchema: savingsPolicyEdit,
    validate: (values) => {
      const errors = {};
      // if (
      //   values.interest_posting_period === "daily" &&
      //   values.interest_compound_period === "monthly"
      // ) {
      //   errors.interest_compound_period =
      //     "Compound period cannot be monthly if Posting period is Daily";
      // }
      // if (!values.interest_cal_type) {
      //   errors.interest_cal_type = "Interest Calculation Type is required";
      // }
      // if (!values.interest_posting_period) {
      //   errors.interest_posting_period = "Interest Posting Period is required";
      // }
      // if (!values.interest_compound_period) {
      //   errors.interest_compound_period =
      //     "Interest Compound Period is required";
      // }
      if (parseInt(values?.maximum_age) < parseInt(values?.minimum_age)) {
        errors.min = "Minimum age cannot be greater than maximum age";
        errors.max = "Maximum age cannot be less than minimum age";
      }
      if (
        parseFloat(values?.default_interest_rate) <
        parseFloat(values?.minimum_interest_rate)
      ) {
        errors.default_rate = "Default rate cannot be less than minimum rate";
        errors.min_rate = "Minimum rate cannot be greater than default rate";
      }
      if (
        parseFloat(values?.default_interest_rate) >
        parseFloat(values?.maximum_interest_rate)
      ) {
        errors.default_rate =
          "Default rate cannot be greater than maximum rate";
        errors.max_rate = "Maximum rate cannot be less than default rate";
      }
      if (
        parseFloat(values?.maximum_interest_rate) <
        parseFloat(values?.minimum_interest_rate)
      ) {
        errors.min_rate = "Minimum rate cannot be greater than maximum rate";
        errors.max_rate = "Maximum rate cannot be less than minimum rate";
      }
      if (
        (!values.specific_offices || values.specific_offices.length === 0) &&
        values?.apply_to === "SO"
      ) {
        errors.specific_offices = "At least one specific office is required";
      }
      // if (values?.cover?.every((item) => item === "")) {
      //   flash("error", "Atleast one cover is required");
      //   return;
      // }
      // check if there atleast one cover for. If not, go to cover for tab.
      if (values?.lifeCover?.every((item) => item === "")) {
        flash("error", "Atleast one life cover is required");
        return;
      }
      if (values?.life_cover_claim_name === 'multiple' && values.multiple_value.length < 1) {
        errors.multiple_value = "Atleast one value must be selected";
      }
      if (values?.life_cover_claim_name === "guaranteed" && values?.assumed_garranty_type === "fixed" && values?.assumed_garranty_value === "") {
          errors.assumed_garranty_value = "Fixed value is required";  
      }
      if (values?.life_cover_claim_name === "guaranteed" && values?.assumed_garranty_type === "range" && (values?.assumed_garranty_maximum === "" || values?.assumed_garranty_minimum === "")) {
          errors.assumed_garranty_maximum = "Both Min and Max are required";  
      }
      if (values?.life_cover_claim_name === "guaranteed" && values?.assumed_garranty_type === "range" && (parseFloat(values?.assumed_garranty_maximum) < parseFloat(values?.assumed_garranty_minimum))) {
          errors.assumed_garranty_maximum = "Minimum cannot be greater than Maximum";  
      }

      return errors;
    },
    onSubmit,
  });

  useEffect(() => {
    const payload = {
      id: id,
      office_id: user?.office_id,
    };
    dispatch(getSingleSavingsPolicy(payload));
    dispatch(getPolicyCoverByCategory(2));
    dispatch(getUnpaginatedCharges());
  }, []);

  useEffect(() => {
    setPolicy(single_policy?.data);
    if (gl_accounts) {
      setGLAccounts(gl_accounts);
    }
    if (!isLoading) {
      setEdit(false);
      dispatch(resetPolicyStatus());
    }
  }, [single_policy?.data, gl_accounts, isUpdated]);

  useLayoutEffect(() => {
    if (isSuccess) {
      const payload = {
        id: id,
        office_id: user?.office_id,
      };

      dispatch(getSingleSavingsPolicy(payload));
      dispatch(resetPolicyStatus());
    }
  }, [isSuccess, isUpdated]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "settings module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "policy configuration module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "view policy details"
      )
    ) {
      navigate("/admin/dashboard");
    }
    setHasEditPolicy(
      user_permissions?.some((permission) => permission.name === "edit policy")
    );
  }, [navigate, user_permissions]);

  // useEffect(() => {
  //   dispatch(getGlAccounts());
  // }, []);

  return (
    <>
      {/* page title */}
      <PageTitle title='Edit Policy' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* Table row */}

      {!single_policy && (
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      )}

      {single_policy?.data && (
        <div
          className='position-relative row mt- card p-1'
          style={{ margin: "auto 1px" }}
        >
          <form onSubmit={handleSubmit}>
            <div className='row mb-2'>
              <GeneralInformation
                p_gen_info={policy?.savings_policy_general}
                values={values}
                errors={errors}
                edit={edit}
                touched={touched}
                handleBlur={handleBlur}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
              />
            </div>
            <div className='row mb-1'>
              <SavingsInterest
                rate={policy?.interest}
                values={values}
                errors={errors}
                edit={edit}
                touched={touched}
                handleBlur={handleBlur}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
              />
            </div>
            <div className='row mb-1'>
              <Account
                p_account_info={policy?.account}
                values={values}
                errors={errors}
                edit={edit}
                touched={touched}
                gl_accounts={glAccounts}
                handleBlur={handleBlur}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
              />
            </div>

            {/* <div className='row mb-3'>
              <Charges
                p_charges_info={policy?.p_charges_info}
                errors={errors}
                edit={edit}
                touched={touched}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                getFieldProps={getFieldProps}
              />
            </div> */}

            <div className='row mb-2'>
              <Cover
                p_cover={policy?.cover}
                values={values}
                errors={errors}
                edit={edit}
                touched={touched}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                getFieldProps={getFieldProps}
              />
            </div>
            <div className='row mb-2'>
              <Settings
                p_setting={policy?.settings}
                values={values}
                errors={errors}
                edit={edit}
                touched={touched}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                getFieldProps={getFieldProps}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                policy={policy}
              />
            </div>

            {hasEditPolicy && (
              <div className='my-2 d-flex justify-content-end '>
                {edit ? (
                  <>
                    <button
                      type='button'
                      className='btn btn-sm btn-secondary  me-2'
                      onClick={() => {
                        setEdit(false);
                        resetForm();
                      }}
                    >
                      Close
                    </button>
                    <button type='submit' className='btn btn-sm btn-success'>
                      Save
                    </button>
                  </>
                ) : (
                  <button
                    type='button'
                    className='btn btn-sm btn-info'
                    onClick={() => setEdit(true)}
                  >
                    Edit
                  </button>
                )}
              </div>
            )}
          </form>
          {/* <AddCoverModal modal_id={"add-cover"} /> */}
          {isLoading && edit && <Loading />}
        </div>
      )}
    </>
  );
};

export default EditSavingsPolicy;
